// Alerts
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

// Auth
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const PROFILE_UPDATE_LOADING = 'PROFILE_UPDATE_LOADING';
export const PROFILE_UPDATE_LOADED = 'PROFILE_UPDATE_LOADED';
export const ACCOUNT_LOADING = 'ACCOUNT_LOADING';
export const ACCOUNT_LOADING_DONE = 'ACCOUNT_LOADING_DONE';
export const PEOPLE_LOADING = 'PEOPLE_LOADING';
export const GET_USER = 'GET_USER';
export const GET_USERS = 'GET_USERS';
export const SET_USERS = 'SET_USERS';
export const SET_PEOPLE = 'SET_PEOPLE';
export const GET_PROFILE_USER = 'GET_PROFILE_USER';
export const UPDATE_AUTH = 'UPDATE_AUTH';
export const UPDATE_USER_IMG = 'UPDATE_USER_IMG';
export const AUTH_ERROR = 'AUTH_ERROR';
export const USER_ERROR = 'USER_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const SET_SIDEBAR = 'SET_SIDEBAR';
export const CLEAR_USER = 'CLEAR_USER';
export const CLEAR_PROFILE_USER = 'CLEAR_PROFILE_USER';
export const CLEAR_PEOPLE = 'CLEAR_PEOPLE';
export const SET_SHOW_BOTTOM_SPINNER_4_USERS = 'SET_SHOW_BOTTOM_SPINNER_4_USERS';
export const SET_LAST_USER_DOC = 'SET_LAST_USER_DOC';
export const SET_NO_MORE_USERS = 'SET_NO_MORE_USERS';
export const SET_LAST_USERS = 'SET_LAST_USERS';

// Nav
export const SET_NAV1 = 'SET_NAV1';
export const SET_NAV2 = 'SET_NAV2';
export const SET_NAV3 = 'SET_NAV3';
export const REMOVE_NAV1 = 'REMOVE_NAV1';
export const REMOVE_NAV2 = 'REMOVE_NAV2';
export const REMOVE_NAV3 = 'REMOVE_NAV3';
export const SET_PAGE = 'SET_PAGE';
export const TOGGLE_USER_MODAL = 'TOGGLE_USER_MODAL';
export const TOGGLE_PROFILE_MODAL = 'TOGGLE_PROFILE_MODAL';
export const TOGGLE_CREATE_GROUP_MODAL = 'TOGGLE_CREATE_GROUP_MODAL';
export const TOGGLE_CREATE_MATCH_MODAL = 'TOGGLE_CREATE_MATCH_MODAL';
export const TOGGLE_AUTH_MODAL = 'TOGGLE_AUTH_MODAL';
export const TOGGLE_PRIVACY_MODAL = 'TOGGLE_PRIVACY_MODAL';
export const TOGGLE_MESSAGE_MODAL = 'TOGGLE_MESSAGE_MODAL';
export const SET_AUTH_MODAL = 'SET_AUTH_MODAL';
export const SET_PRIVACY_MODAL = 'SET_PRIVACY_MODAL';
export const TOGGLE_VERIFY_MODAL = 'TOGGLE_VERIFY_MODAL';
export const TOGGLE_VERIFY_SCHOOL_MODAL = 'TOGGLE_VERIFY_SCHOOL_MODAL';
export const SET_PROFILE_MODAL = 'SET_PROFILE_MODAL';
export const TOGGLE_POST_MODAL = 'TOGGLE_POST_MODAL';
export const SET_POST_MODAL = 'SET_POST_MODAL';
export const TOGGLE_COMMENT_MODAL = 'TOGGLE_COMMENT_MODAL';
export const SET_COMMENT_MODAL = 'SET_COMMENT_MODAL';
export const TOGGLE_SHARE_MODAL = 'TOGGLE_SHARE_MODAL';
export const SET_MAIN_NAV = 'SET_MAIN_NAV';
export const TOGGLE_SIDE_NAV = 'TOGGLE_SIDE_NAV';
export const TOGGLE_ITEM_MODAL = 'TOGGLE_ITEM_MODAL';
export const TOGGLE_COLLECTION_MODAL = 'TOGGLE_COLLECTION_MODAL';
export const TOGGLE_LOCATION_MODAL = 'TOGGLE_LOCATION_MODAL';
export const REMOVE_ITEM_MODAL = 'REMOVE_ITEM_MODAL';
export const REMOVE_COLLECTION_MODAL = 'REMOVE_COLLECTION_MODAL';
export const REMOVE_LOCATION_MODAL = 'REMOVE_LOCATION_MODAL';
export const SET_SCROLL_TO_TOP = 'SET_SCROLL_TO_TOP';
// Marketplace  
export const SET_IS_MARKETPLACE = 'SET_IS_MARKETPLACE';  
// Driver Portal
export const TOGGLE_QUIT_DELIV_MODAL = 'TOGGLE_QUIT_DELIV_MODAL'; 
export const TOGGLE_START_DELIV_MODAL = 'TOGGLE_START_DELIV_MODAL'; 
export const TOGGLE_CONFIRM_PICKUP_MODAL = 'TOGGLE_CONFIRM_PICKUP_MODAL'; 
export const TOGGLE_CUSTOMER_CODE_MODAL = 'TOGGLE_CUSTOMER_CODE_MODAL'; 
// Custom URL Logic
export const GET_WEBSITE = 'GET_WEBSITE';
export const CLEAR_WEBSITE = 'CLEAR_WEBSITE';
// Security Logic
export const SET_COUNTRY_CODE = 'SET_COUNTRY_CODE';
export const SET_CONTINENT_NAME = 'SET_CONTINENT_NAME';
export const SET_FIREWALL = 'SET_FIREWALL'; 
    

// Posts
export const GET_POSTS = 'GET_POSTS';
export const SET_POSTS = 'SET_POSTS';
export const SET_LAST_POSTS = 'SET_LAST_POSTS';
export const GET_POST = 'GET_POST';
export const UPDATE_POST_LIKES = 'UPDATE_POST_LIKES';
export const ADD_POST = 'ADD_POST';
export const DELETE_POST = 'DELETE_POST';
export const GET_COMMENTS = 'GET_COMMENTS';
export const SET_COMMENTS = 'SET_COMMENTS';
export const ADD_COMMENT = 'ADD_COMMENT';
export const REMOVE_COMMENT = 'REMOVE_COMMENT';
export const COMMENTS_LOADING = 'COMMENTS_LOADING';
export const POSTS_LOADING = 'POSTS_LOADING';
export const CLEAR_POSTS = 'CLEAR_POSTS';
export const CLEAR_POST = 'CLEAR_POST';
export const POST_ERROR = 'POST_ERROR';
export const UPDATE_EDITOR_TEXT = 'UPDATE_EDITOR_TEXT';
export const CLEAR_EDITOR_TEXT = 'CLEAR_EDITOR_TEXT';
export const UPDATE_EDITOR_CATEGORY = 'UPDATE_EDITOR_CATEGORY';
export const CLEAR_EDITOR_CATEGORY = 'CLEAR_EDITOR_CATEGORY';
export const UPDATE_EDITOR_FILES = 'UPDATE_EDITOR_FILES';
export const REMOVE_EDITOR_FILE = 'REMOVE_EDITOR_FILE';
export const CLEAR_EDITOR_FILES = 'CLEAR_EDITOR_FILES';
export const UPDATE_URLS = 'UPDATE_URLS';
export const REMOVE_URL = 'REMOVE_URL';
export const CLEAR_URLS = 'CLEAR_URLS';
export const UPDATE_LAST_POST_ADDED = 'UPDATE_LAST_POST_ADDED';
export const POST_UPLOADING = 'POST_UPLOADING';
export const POST_UPLOADING_IMGS = 'POST_UPLOADING_IMGS';
export const SET_SHOW_BOTTOM_SPINNER = 'SET_SHOW_BOTTOM_SPINNER';
export const SET_LAST_PAGE_DOC = 'SET_LAST_PAGE_DOC';
export const SET_NO_MORE_POSTS = 'SET_NO_MORE_POSTS';

// Chats
export const CHATS_LOADING = 'CHATS_LOADING';
export const CHAT_LOADING = 'CHAT_LOADING';
export const GET_CHAT = 'GET_CHAT';
export const GET_CHATS = 'GET_CHATS';
export const CREATE_CHAT = 'CREATE_CHAT';
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const GET_MESSAGES = 'GET_MESSAGES';
export const SET_MESSAGES = 'SET_MESSAGES';
export const SET_MESSAGE = 'SET_MESSAGE';
export const UPDATE_LAST_MESSAGE = 'UPDATE_LAST_MESSAGE';
export const SET_UNREAD_CHATS = 'SET_UNREAD_CHATS';
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';
export const CHAT_ERROR = 'CHAT_ERROR';
export const CLEAR_CHAT = 'CLEAR_CHAT';
export const CLEAR_CHATS = 'CLEAR_CHATS';
export const UPDATE_EDITOR_IMG_FILE = 'UPDATE_EDITOR_IMG_FILE';
export const CLEAR_EDITOR_IMG_FILE = 'CLEAR_EDITOR_IMG_FILE';
export const UPDATE_IMG_URL = 'UPDATE_IMG_URL';
export const REMOVE_IMG_URL = 'REMOVE_IMG_URL';

// Notifications
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const SET_LAST_NOTIFICATIONS = 'SET_LAST_NOTIFICATIONS';
export const GET_ACTIVITY = 'GET_ACTIVITY';
export const SET_UNREAD_COUNT = 'SET_UNREAD_COUNT';
export const NOTIFICATION_ERROR = 'NOTIFICATION_ERROR';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';
export const NOTIFICATIONS_LOADING = 'NOTIFICATIONS_LOADING';
    
// Searches
export const GET_RECENT_SEARCHES = 'GET_RECENT_SEARCHES';
export const GET_POPULAR_SEARCHES = 'GET_POPULAR_SEARCHES';
export const SEARCHES_ERROR = 'SEARCHES_ERROR';
export const CLEAR_POPULAR_SEARCHES = 'CLEAR_POPULAR_SEARCHES';
export const POPULAR_SEARCHES_LOADING = 'POPULAR_SEARCHES_LOADING';
export const CLEAR_RECENT_SEARCHES = 'CLEAR_RECENT_SEARCHES';
export const RECENT_SEARCHES_LOADING = 'RECENT_SEARCHES_LOADING';
export const DELETE_RECENT_SEARCH = 'DELETE_RECENT_SEARCH';
export const SET_SHOW_BOTTOM_SPINNER_4_SEARCHES = 'SET_SHOW_BOTTOM_SPINNER_4_SEARCHES';
export const SET_LAST_SEARCH_DOC = 'SET_LAST_SEARCH_DOC';
export const SET_NO_MORE_SEARCHES = 'SET_NO_MORE_SEARCHES';
export const SET_LAST_POPULAR_SEARCHES = 'SET_LAST_POPULAR_SEARCHES';
export const SET_POPULAR_SEARCHES = 'SET_POPULAR_SEARCHES';

// Ads
export const GET_ADS = 'GET_ADS';
export const SET_ADS = 'SET_ADS';
export const SET_LAST_ADS = 'SET_LAST_ADS';
export const AD_ERROR = 'AD_ERROR';
export const CLEAR_ADS = 'CLEAR_ADS';
export const ADS_LOADING = 'ADS_LOADING';
export const GET_AD = 'GET_AD';

// Groups
export const GET_GROUP = 'GET_GROUP';
export const GET_GROUPS = 'GET_GROUPS';
export const GET_MODAL_GROUPS = 'GET_MODAL_GROUPS';
export const SET_SELECTED_GROUP = 'SET_SELECTED_GROUP';
export const SET_GROUPS = 'SET_GROUPS';
export const SET_LAST_GROUPS = 'SET_LAST_GROUPS';
export const GROUP_ERROR = 'GROUP_ERROR';
export const CLEAR_GROUPS = 'CLEAR_GROUPS';
export const CLEAR_GROUP = 'CLEAR_GROUP';
export const GROUPS_LOADING = 'GROUPS_LOADING';
export const UPDATE_GROUP = 'UPDATE_GROUP';
export const GROUP_UPDATE_LOADING = 'GROUP_UPDATE_LOADING';
export const GROUP_UPDATE_LOADED = 'GROUP_UPDATE_LOADED';
export const SET_SHOW_BOTTOM_SPINNER_4_GROUPS = 'SET_SHOW_BOTTOM_SPINNER_4_GROUPS';
export const SET_LAST_GROUP_DOC = 'SET_LAST_GROUP_DOC';
export const SET_NO_MORE_GROUPS = 'SET_NO_MORE_GROUPS';

// Sport Matches
export const GET_MATCH = 'GET_MATCH';
export const GET_MATCHES = 'GET_MATCHES';
export const SET_MATCHES = 'SET_MATCHES';
export const SET_LAST_MATCHES = 'SET_LAST_MATCHES';
export const MATCH_ERROR = 'MATCH_ERROR';
export const CLEAR_MATCHES = 'CLEAR_MATCHES';
export const CLEAR_MATCH = 'CLEAR_MATCH';
export const MATCHES_LOADING = 'MATCHES_LOADING';
export const UPDATE_MATCH = 'UPDATE_MATCH';
export const MATCH_UPDATE_LOADING = 'MATCH_UPDATE_LOADING';
export const MATCH_UPDATE_LOADED = 'MATCH_UPDATE_LOADED';
export const SET_SHOW_BOTTOM_SPINNER_4_MATCHES = 'SET_SHOW_BOTTOM_SPINNER_4_MATCHES';
export const SET_LAST_MATCH_DOC = 'SET_LAST_MATCH_DOC';
export const SET_NO_MORE_MATCHES = 'SET_NO_MORE_MATCHES';

// Categories
export const GET_CATEGORY = 'GET_CATEGORY';
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_LAST_CATEGORIES = 'SET_LAST_CATEGORIES';
export const CATEGORY_ERROR = 'CATEGORY_ERROR';
export const CLEAR_CATEGORIES = 'CLEAR_CATEGORIES';
export const CLEAR_CATEGORY = 'CLEAR_CATEGORY';
export const CATEGORIES_LOADING = 'CATEGORIES_LOADING';
export const SET_SHOW_BOTTOM_SPINNER_4_CATEGORIES = 'SET_SHOW_BOTTOM_SPINNER_4_CATEGORIES';
export const SET_LAST_CATEGORY_DOC = 'SET_LAST_CATEGORY_DOC';
export const SET_NO_MORE_CATEGORIES = 'SET_NO_MORE_CATEGORIES';